import React, { useContext, useEffect } from 'react'
import { StoresContext } from '@App/contexts'
import { MemberSummary } from '@Entities/member/member-summary'
import RightsholderSummaryCard from '@Components/Cards/RightsholderSummaryCard'
import AddRightsholderCard from '@Components/Cards/AddRightsholderCard'
import { observer } from 'mobx-react'
import { useNavigate } from 'react-router'
import Navigation from '@App/navigation'

const MemberSummarySection = () => {
    const navigate = useNavigate()
    const { rightsholderSearchStore } = useContext(StoresContext)

    const allDoneRightsHolders = rightsholderSearchStore.rightsholders

    useEffect(() => {
        if (rightsholderSearchStore.rightsholderCount === 1) {
            navigate(Navigation.rightholder.summary(allDoneRightsHolders.content[0].ipId))
        }
    }, [rightsholderSearchStore.rightsholderCount])

    return (
        <section className="rightsholder-summary-section">
            {allDoneRightsHolders?.content.map((item: MemberSummary) => (
                <RightsholderSummaryCard key={item.ipId} rightsHolderInfo={{ ...item }} />
            ))}
            {allDoneRightsHolders && !allDoneRightsHolders.totalElements && <AddRightsholderCard />}
        </section>
    )
}

export default observer(MemberSummarySection)
